import type { Store, MutationTree } from "vuex";
import type { State } from "@/store/state";
import type { MapState } from "./state";
import type { GISLayerBase } from "@/interfaces/gis_layer";

export const mutations: MutationTree<MapState> = {
  setMapCenter(state, payload: { lat: number; lng: number }): void {
    state.center = payload;
  },
  setMapZoom(state, payload: number): void {
    state.zoom = payload;
  },
  setGISLayers(state, payload: GISLayerBase[]): void {
    state.GISLayers = payload;
  },
};

const NS = "map/";

export const commitSetMapCenter = (
  store: Store<State>,
  payload: { lat: number; lng: number },
): void => {
  store.commit(`${NS}setMapCenter`, payload);
};

export const commitSetMapZoom = (
  store: Store<State>,
  payload: number,
): void => {
  store.commit(`${NS}setMapZoom`, payload);
};

export const commitSetGISLayers = (
  store: Store<State>,
  payload: GISLayerBase[],
): void => {
  store.commit(`${NS}setGISLayers`, payload);
};
